import { useState } from "react";
import Joi from "joi-browser";

export default useEvalRunConfigForm;
export { evalRunConfigSchema };

const evalRunConfigSchema = {
  // Optional: the backend derives a name from the persona names when this is
  // blank, so naming is an affordance rather than a gate on every run.
  name: Joi.string().allow("", null).max(120).label("Name"),
  modelsToTest: Joi.array().min(1).label("Models"),
  personas: Joi.array().min(1).label("Personas"),
  // Plain strings, global to the run. The expected outcome is per-persona and
  // lives on the persona, since these same criteria judge every one of them.
  qualityCriteria: Joi.array()
    .items(Joi.string().disallow("").required())
    .min(1)
    .required()
    .label("Quality Criteria"),
  maxTurns: Joi.number().required().label("Max Turns"),
  simulationMode: Joi.string().required().label("Simulation Mode"),
  evaluatorModel: Joi.string().required().label("Evaluator Model"),
  customerSimulatorModel: Joi.string()
    .required()
    .label("Customer Simulator Model"),
  eventsToTrack: Joi.array().optional().label("Events to Track"),
  expectedEvents: Joi.array().optional().label("Expected Events"),
  endCriteria: Joi.string()
    .when("simulationMode", {
      is: "chat",
      then: Joi.string().required(),
      otherwise: Joi.string().allow(null, ""),
    })
    .label("End Criteria"),
};

function getEvalRunConfigState(evalRunConfig) {
  return {
    name: evalRunConfig?.name ?? "",
    modelsToTest: evalRunConfig?.modelsToTest ?? [],
    personas: evalRunConfig?.personas ?? [],
    qualityCriteria: evalRunConfig?.qualityCriteria ?? [],
    maxTurns: evalRunConfig?.maxTurns ?? 10,
    simulationMode: evalRunConfig?.simulationMode ?? "voice",
    evaluatorModel: evalRunConfig?.evaluatorModel ?? "gemini-3-flash-preview",
    customerSimulatorModel: evalRunConfig?.customerSimulatorModel ?? "gpt-4.1-mini",
    eventsToTrack: evalRunConfig?.eventsToTrack ?? [],
    expectedEvents: evalRunConfig?.expectedEvents ?? []
  }
}

function useEvalRunConfigForm(evalRunConfig) {
  const [formState, setFormState] = useState(() => getEvalRunConfigState(evalRunConfig));
  const [errors, setErrors] = useState({});

  const validate = () => {
      const schema = Joi.object(evalRunConfigSchema);
      const { error } = schema.validate(formState, { abortEarly: false });
  
      if (!error) {
        setErrors({});
        return true;
      }
  
      const fieldErrors = {};
      error.details.forEach((detail) => {
        if (detail.path.length > 1) {
          // Array field — e.g. path: ['tags', 0]
          const field = detail.path[0];
          const index = detail.path[1];
          if (!Array.isArray(fieldErrors[field])) {
            fieldErrors[field] = [];
          }
          fieldErrors[field][index] = detail.message;
        } else {
          fieldErrors[detail.path[0]] = detail.message;
        }
      });
  
      console.log({ fieldErrors });
  
      setErrors(fieldErrors);
      return false;
    };

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  return {
    formState,
    errors,
    updateFormState,
    validate,
  };
}
